import React, { useState } from "react";
import "./ToolModify.css";
import { getIcon } from "../../../utils/icons";
import { useDispatch } from 'react-redux';
import { setCommandType } from "../../../redux/operationSlice";
import { COMMANDS } from "../../../utils/commonProperties";

const ToolModify = () => {
  const [activeButton, setActiveButton] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const buttonSize = 30;
  const dispatch = useDispatch();

  const handleClick = (tool) => {
    setActiveButton(tool === activeButton ? null : tool);
    dispatch(setCommandType(COMMANDS[tool.toUpperCase()]));
  };

  return (
    <div className={`toolModify ${isOpen ? "open" : "closed"}`}>
      {/* Sol kolon: butonlar */}
      {isOpen && (
        <div className="toolModify-left">
          <div className="toolRow">
            {[
              "move",
              "erase",
              "copy",
              "rotate"
            ].map((tool) => (
              <button
                key={tool}             
                className={`toolButton ${activeButton === tool ? "active" : ""}`}
                style={{ width: `${buttonSize}px`, height: `${buttonSize}px` }}
                onClick={() => handleClick(tool)}
              >
                {getIcon(tool, buttonSize)}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Sağ kolon: toggle butonu */}
      <div className="toolModify-toggle">
        <button
          className="toolButton toggleArrowButton"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {isOpen ? "◀" : "Modify▶"}
        </button>
      </div>
    </div>
  );
};

export default ToolModify;
